module.exports = __webpack_public_path__ + "media/application/images/ui/icon-chevron-c52b71e3a1cd28c4156136820bafab29.png";